import ClauseSectionType from '../types/ClauseSectionType';
import store from '../../store/store';
import InboxRuleSectionCompletionStatus from '../../store/schema/InboxRuleSectionCompletionStatus';
import isValidClause, { isValidSection } from '../../utils/isValidClause';

export default function getSectionCompletionStatus(
    sectionType: ClauseSectionType,
    sectionClauseIds: string[]
): InboxRuleSectionCompletionStatus {
    const focusedClauseId = store.inboxRulesEditState.focusedClauseId;

    // name section is a special case -- no clause Id
    if (sectionType == 'name') {
        if (focusedClauseId == 'name') {
            return InboxRuleSectionCompletionStatus.InProgress;
        } else if (
            store.inboxRulesEditState.ruleName &&
            store.inboxRulesEditState.ruleName.trim().length > 0
        ) {
            return InboxRuleSectionCompletionStatus.Complete;
        } else {
            return InboxRuleSectionCompletionStatus.Incomplete;
        }
    }

    // we are guaranteed to have at lease one clause in a section
    const firstClause = store.inboxRulesEditState.clauseMap.get(sectionClauseIds[0]);

    if (sectionClauseIds.indexOf(focusedClauseId) > -1) {
        return InboxRuleSectionCompletionStatus.InProgress;
    } else if (
        isValidSection(sectionType) &&
        firstClause.clauseType &&
        isValidClause(sectionClauseIds[0])
    ) {
        // Possible for valid sections to be incomplete (e.g. empty optional section is still valid)
        // check that there is at least 1 valid clause in section
        return InboxRuleSectionCompletionStatus.Complete;
    } else {
        return InboxRuleSectionCompletionStatus.Incomplete;
    }
}
